import { APIURL } from "./config";
import axios from "axios";
import { toast } from "react-toastify";
import {
  NOTIFICATION_LIST,
  UNVIEWED_NOTIFICATION_LIST,
  NOTIFICATION_DELETE,
  LOADING,
  NOT_FOUND
} from "./type";

// Unclosed
export const notificationList = () => async (dispatch) => {
  dispatch({
    type:LOADING,
    payload:''
  })
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.get(
      `${APIURL}/api/v1/notifications/unclosed-notifications`,
      config
    );
    if(res.data){
      dispatch({
        type: NOTIFICATION_LIST,
        payload: res.data,
      });
    }
    if(res.data?.data?.notification?.length === 0){
      dispatch({
        type:NOT_FOUND,
        payload:''
      })
    }
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};

// Unviewed
export const UnviewedNotificationList = () => async (dispatch) => {
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.get(
      `${APIURL}/api/v1/notifications/unviewed-notifications`,
      config
    );
    dispatch({
      type: UNVIEWED_NOTIFICATION_LIST,
      payload: res.data,
    });
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};

export const ViewAllNotifications = () => async (dispatch) => {
  const token = localStorage.getItem("token");

  var myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);

  var requestOptions = {
    method: "PATCH",
    headers: myHeaders,
    redirect: "follow",
  };

  fetch(`${APIURL}/api/v1/notifications/isViewedTrue`, requestOptions)
    .then((response) => response.json())
    // .then((result) => console.log(result))
    .catch((error) => console.log("error", error));
};

export const deleteNotification = (id,callBack) => async (dispatch) => {
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    // if (window.confirm("Do you want to delete notifications")) {
    const res = await axios.delete(
      `${APIURL}/api/v1/notifications/${id}`,
      config
    );
      if(res?.data?.status === 'success'){
        callBack('success')
        dispatch({
          type: NOTIFICATION_DELETE,
          payload: res.data,
        });
      }
    // }
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};
